<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><a class="page" id="piv"></a>New York and London</p>
<p class="crt"><a class="url" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="crtf">Copyright © 1990 by New York University</p>
<p class="crt">All rights reserved</p>
<p class="crtf">First published in paperback in 2007.</p>
<p class="crt">New revised edition published in 2015.</p>
<p class="crtf">e-ISBN: 978-1-4798-6995-4</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Skousen, Mark.</p>
<p class="cip1">The structure of production / Mark Skousen; with a new introduction. — New revised edition.</p>
<p class="cip2">pages cm</p>
<p class="cip1">Includes bibliographical references and index.</p>
<p class="cip1">ISBN 978-1-4798-4852-2 (pb: alk. paper)</p>
<p class="cip1">1. Production (Economic theory) 2. Macroeconomics. I. Title.</p>
<p class="cipf1">HB241.S63 2015</p>
<p class="cipf1">338.5—dc23</p>
<p class="cip1f">2015006888</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyu-skousen-0004.vue?7b2e910c